var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql, useQuery } from '@apollo/client';
// TEAM_SURVEYS
var TEAM_SURVEYS = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query TeamSurveys($id: ID!) {\n    team(id: $id) {\n      id\n      surveys {\n        id\n        title\n      }\n    }\n  }\n"], ["\n  query TeamSurveys($id: ID!) {\n    team(id: $id) {\n      id\n      surveys {\n        id\n        title\n      }\n    }\n  }\n"])));
export var useTeamSurveysQuery = function (options) {
    return useQuery(TEAM_SURVEYS, options);
};
export default TEAM_SURVEYS;
var templateObject_1;
